// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"801ad12c","239":"446bb8cc","453":"2db0b49d","732":"c1363208"}[chunkId] + ".chunk.js";
};